export class CargoEntity {
    name!:string;
    url!:string;
    cargo_id!: number;
    enabled: number = 1;
    min_basket_price!: number;
    price!: number;
    kapida_odeme_price!: number;
    created_at!:string;
    updated_at!:string;
}